<atlas-accordion *ngIf="data.length > 0">
  <atlas-accordion-item #accordionRef *ngFor="let item of data; let i = index" [expanded]="item.expanded"
    (onExpand)="toggleExpanded(i)" [arrowIconRight]="false" [group]="true">

    <atlas-accordion-heading>
      <div class="row">
        <div class="columns expand mos-o-body-2 mos-u-align-center--vertical">
          <span>{{ item.fund.name }}</span>
        </div>
      </div>
    </atlas-accordion-heading>
    <atlas-accordion-content>
      <ng-container *ngIf="!item.transactions.length">
        <div class="mos-u-align-center--both" [style.height.px]="100">
          <b>No transactions for selected period.</b>
        </div>
      </ng-container>
      <atlas-table *ngIf="item.transactions.length">
        <!-- <thead atlas-table-header #header>
        </thead> -->
        <thead atlas-table-header #header>
          <tr *ngIf="country==='au'" atlas-table-row>
            <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col">
              {{ col.displayLabel }}
            </th>
          </tr>
          <tr *ngIf="country==='nz'" atlas-table-row>
            <th atlas-table-header-cell *ngFor="let col of headersNZ" [columnDef]="col">
              {{ col.displayLabel }}
            </th>
          </tr>
        </thead>
        <tbody atlas-table-body>
          <tr halo-table-row *ngFor="let row of item.transactions;let index=index">
            <td atlas-table-cell>
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [id]="formatId(fundIndex, index, 'date')" class="typographyStyles-body-small">
                  {{ row.date | date: 'dd/MM/yyyy':'+0000' }}
                </span>
              </ng-container>
            </td>
            <td atlas-table-cell>
              <ng-container *ngIf="index === 0 || (item.total <= 10 && index === item.transactions.length - 1)">
                <span class="dsp-opening-closing typographyStyles-body-small"
                  [id]="formatId(fundIndex, index, index === 0 ? 'opening-description' : 'closing-description')">
                  {{ row.description }}
                </span>
              </ng-container>
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [haloTooltipWithArrow]="true" [haloTooltip]="row.description" haloTooltipPosition="right"
                  haloTooltipShowDelay="100" [id]="formatId(fundIndex, index, 'description')"
                  [class.dsp-opening-closing]="row.description === 'Closing Balance'"
                  class="typographyStyles-body-small">{{ row.description
                  }}</span>
              </ng-container>
            </td>
            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index === 0 || (item.total <= 10 && index === item.transactions.length - 1)">
                <span class="dsp-opening-closing typographyStyles-body-small"
                  [id]="formatId(fundIndex, index, index === 0 ? 'opening-amount' : 'closing-amount')">
                  {{ row.amount && row.amount !== 0 ? (row.amount | decimal:'$') : '-' }}
                </span>
              </ng-container>
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [id]="formatId(fundIndex, index, 'amount')"
                  [class.dsp-opening-closing]="row.description === 'Closing Balance'"
                  class="typographyStyles-body-small">
                  {{ row.amount && row.amount !== 0 ? (row.amount | decimal:'$') : '-' }}
                </span>
              </ng-container>
            </td>
            <td atlas-table-cell *ngIf="country==='nz'" class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span class="typographyStyles-body-small" [id]="formatId(fundIndex, index, 'pieTaxPaid')">
                  {{ row.pieTaxPaid && row.pieTaxPaid !== 0 ? (row.pieTaxPaid | decimal:'$') : '-'}}
                </span>
              </ng-container>

            </td>
            <td atlas-table-cell *ngIf="country==='nz'" class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span class="typographyStyles-body-small" [id]="formatId(fundIndex, index, 'netAmountFundCurrency')">
                  {{ row.netAmountFundCurrency && row.netAmountFundCurrency !== 0 ? (row.netAmountFundCurrency |
                  decimal:'$') : '-'}}
                </span>
              </ng-container>

            </td>
            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index === 0 || (item.total <= 10 && index === item.transactions.length - 1)">
                <span class="dsp-opening-closing typographyStyles-body-small"
                  [id]="formatId(fundIndex, index, index === 0 ? 'opening-unit-price' : 'closing-unit-price')">
                  {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$'): '-' }}
                </span>
              </ng-container>
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [id]="formatId(fundIndex, index, 'unit-price')"
                  [class.dsp-opening-closing]="row.description === 'Closing Balance'"
                  class="typographyStyles-body-small">
                  {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
                </span>
              </ng-container>
            </td>
            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [id]="formatId(fundIndex, index, 'units')" class="typographyStyles-body-small">
                  {{ row.units && row.units !== 0 ? (row.units | decimal) : '-' }}
                </span>
              </ng-container>
            </td>
            <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
              <ng-container *ngIf="index === 0 || (item.total <= 10 && index === item.transactions.length - 1)">
                <span class="dsp-opening-closing typographyStyles-body-small"
                  [id]="formatId(fundIndex, index, index === 0 ? 'opening-unit-balance' : 'closing-unit-balance')">
                  {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
                </span>
              </ng-container>
              <ng-container *ngIf="index !== 0 && (item.total > 10 || index !== item.transactions.length - 1)">
                <span [id]="formatId(fundIndex, index, 'unit-balance')"
                  [class.dsp-opening-closing]="row.description === 'Closing Balance'"
                  class="typographyStyles-body-small">
                  {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
                </span>
              </ng-container>
            </td>

          </tr>
        </tbody>
      </atlas-table>
      <div *ngIf="item.total > 10" class="dsp-transactions-view-more-row">

        <atlas-button [id]="'view-more-button'" [size]="'small'" variant="text" (click)="onOpenModal({ fund: item.fund._id, from: from, to: to,
        accountId : accountId })">
          <!-- <atlas-icon [icon]="'arrow_forward'" [alt]="'view more'"></atlas-icon> -->
          <atlas-icon [icon]="'icon-arrow-right-24'" [alt]="'view more'"></atlas-icon>
          <span class="mos-u-spacer--padding-right-xxxsm mos-u-spacer--padding-left-xxxsm">
            VIEW MORE TRANSACTIONS
          </span>
        </atlas-button>
      </div>
    </atlas-accordion-content>


    <atlas-accordion-expand>
      <div>
        <atlas-icon-button collection="arrows-solid"
          [icon]="item.expanded ? 'chevron-up' : 'chevron-down'"></atlas-icon-button>
      </div>
    </atlas-accordion-expand>
  </atlas-accordion-item>
</atlas-accordion>
<dsp-transactions-details>
</dsp-transactions-details>